module.exports = __webpack_public_path__ + "img/icon-pwalogo.b50455e0.svg";